import * as React from 'react'
import { Button, PageHeader } from 'antd'
import { CalculatorOutlined, PlusCircleFilled, PlusCircleOutlined } from '@ant-design/icons'
import { RouteComponentProps, withRouter } from 'react-router'

import { StresstestList } from './StresstestList'
import { withAITracking } from '@microsoft/applicationinsights-react-js'
import { ai } from '../../TelemetryService'


class PageStresstestComp extends React.Component<RouteComponentProps, any> {

    constructor(props) {
        super(props)
    }

    onNewClick = () => {
        this.props.history.push(`Calcola`)
    }

    render() {
        return (
            <PageHeader title="Stress Test" extra={[
                <Button key="new" type="primary" icon={<CalculatorOutlined />} onClick={() => this.onNewClick()}>Scenario</Button>
            ]}>
                <StresstestList />
            </PageHeader>
        )
    }
}

export const PageStresstestList = withRouter(withAITracking(ai.reactPlugin, PageStresstestComp,"PageStresstestList"))